import React from "react";

const Loader = () => <img alt="loading" src="/assets/images/loader.gif" />;

export default Loader;
